<template>
  <div id="alertWxRoot" @click="hideQrcodePage()">
    <div id="alertWxContainer">
      <div id="alertWxTitleDiv">
        请截图后前往微信扫码绑定
      </div>
      <img id="alertWxBackImg" src="~assets/img//rebate-center/close_red.png" @click="hideQrcodePage()"/>
      <div id="alertWxMessageTagParent">
        <img :src="$store.state.qrCodeUrl" alt="">
      </div>
    </div>
  </div>
</template>

<script>
 import { request } from 'network/request';
 import getRequestParams from "@/signParams"
  export default {
    data () {
      return {
      }
    },
    components: {
    },
    methods:{
      // 隐藏提示页面
      hideQrcodePage(){
        this.$store.commit("showWxBindPageState",false)
      }
    },
  }
 </script>

<style>
#alertWxRoot{
    /* display: none; */
    width: 100%;
    height: 100%;
    position: fixed;
    top: 0;
    left: 0;
    background: rgba(51,51,51,0.5);
    z-index: 2233;
  }
  #alertWxContainer{
    width: 300px;
    height: 300px;
    position: relative;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    background: #fff;
    z-index: 2255;
    border-radius: 10px 10px 10px 10px;
  }

  #alertWxTitleDiv{
    width: 300px;
    height: 30px;
    line-height: 30px;
    text-align: center;
    /* background-color: aqua; */
    font-size: x-small;
  }
  #alertWxBackImg{
    float: right;
    height: 30px;
    width: 30px;
    /* 解决图片拉伸问题 */
    object-fit: scale-down;
    margin-top: -30px;
    margin-right: 5px;
  }
  #alertWxMessageTagParent{
    width: 300px;
    height: 250px;
    display: -webkit-box;
    -webkit-box-orient: horizontal;
    -webkit-box-pack: center;
    -webkit-box-align: center;
    
    display: -moz-box;
    -moz-box-orient: horizontal;
    -moz-box-pack: center;
    -moz-box-align: center;
    
    display: -o-box;
    -o-box-orient: horizontal;
    -o-box-pack: center;
    -o-box-align: center;
    
    display: -ms-box;
    -ms-box-orient: horizontal;
    -ms-box-pack: center;
    -ms-box-align: center;
    
    display: box;
    box-orient: horizontal;
    box-pack: center;
    box-align: center;
    
  }
</style>


// WEBPACK FOOTER //
// src/views/alert/AlertWxBind.vue